<script setup>
import { useRouter } from "vue-router";
import logoBlue from "/src/assets/styles/q-logo-blue.png";
import { LanguageSwitch as LangSwitch } from "@/features/language-switch";
import Button from "@/shared/ui/button/Button.vue";

const router = useRouter();
const emit = defineEmits(["toggle-menu"]);
</script>

<template>
  <div class="cabinet-header">
    <div @click="router.push('/')">
      <img v-if="logoBlue" :src="logoBlue" alt="logo" class="logo" />
    </div>

    <div class="flex gap-3">
      <LangSwitch :is-mobile="true"></LangSwitch>

      <Button
        variant="outline"
        size="icon"
        class="menu-button"
        type="button"
        aria-label="Menu"
        @click="emit('toggle-menu')"
      >
        <span class="menu-line"></span>
        <span class="menu-line"></span>
        <span class="menu-line"></span>
      </Button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.cabinet-header {
  @apply w-full flex items-center justify-between py-3;
  // border-bottom: 1px solid rgba(10, 12, 17, 0.06);

  .logo {
    @apply h-7 w-auto;
  }

  .menu-button {
    @apply w-10 h-10 rounded-full flex flex-col items-center justify-center gap-1;
    @apply bg-card;
  }

  .menu-line {
    @apply w-4 h-0.5 bg-foreground rounded-full;
  }
}
</style>
